import React from 'react';
import { VessLogo } from '@/components/ui/VessLogo';
import { currentBrandLabel } from '@/config/resources';

interface BrandMarkProps {
  label?: string;
}

/** The platform wordmark on unbranded auth-adjacent screens. Defaults to the
 * brand of the host we are on; `label` is for the login page, which may resolve
 * its platform from a legacy `?platform=` query param instead. */
export const BrandMark: React.FC<BrandMarkProps> = ({ label = currentBrandLabel() }) => (
  <VessLogo size="lg" label={label} />
);
